// Class: haxe.xml._Access.AttribAccess_Impl_

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../../hxClasses_stub").default;
var $hxEnums = require("./../../../hxEnums_stub").default;
var $import = require("./../../../import_stub").default;
function Xml() {return require("./../../../Xml");}
function js__$Boot_HaxeError() {return require("./../../../js/_Boot/HaxeError");}

// Constructor

var AttribAccess_Impl_ = function(){}

// Meta

AttribAccess_Impl_.__name__ = "haxe.xml._Access.AttribAccess_Impl_";
AttribAccess_Impl_.__isInterface__ = false;
AttribAccess_Impl_.prototype = {
	
};
AttribAccess_Impl_.prototype.__class__ = AttribAccess_Impl_.prototype.constructor = $hxClasses["haxe.xml._Access.AttribAccess_Impl_"] = AttribAccess_Impl_;

// Init



// Statics

AttribAccess_Impl_.resolve = function(this1,name) {
	if(this1.nodeType == (Xml().default).Document) {
		throw new (js__$Boot_HaxeError().default)("Cannot access document attribute " + name);
	}
	var v = this1.get(name);
	if(v == null) {
		throw new (js__$Boot_HaxeError().default)(this1.get_nodeName() + " is missing attribute " + name);
	}
	return v;
}
AttribAccess_Impl_._hx_set = function(this1,name,value) {
	if(this1.nodeType == (Xml().default).Document) {
		throw new (js__$Boot_HaxeError().default)("Cannot access document attribute " + name);
	}
	this1.set(name,value);
	return value;
}


// Export

exports.default = AttribAccess_Impl_;